/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scrape_Router_VideoInputs */

const en_scrape_router_video = /** @type {(inputs: Scrape_Router_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scrape router launch video`)
};

const zh_hans1_scrape_router_video = /** @type {(inputs: Scrape_Router_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`抓取路由发布视频`)
};

const pt_br2_scrape_router_video = /** @type {(inputs: Scrape_Router_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vídeo de lançamento do roteador de scraping`)
};

const es_scrape_router_video = /** @type {(inputs: Scrape_Router_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video de lanzamiento del enrutador de scraping`)
};

const fr_scrape_router_video = /** @type {(inputs: Scrape_Router_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vidéo de lancement du routeur de scraping`)
};

const de_scrape_router_video = /** @type {(inputs: Scrape_Router_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launch-Video zum Scraping-Router`)
};

const ru_scrape_router_video = /** @type {(inputs: Scrape_Router_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Видео о запуске маршрутизатора скрапинга`)
};

const it_scrape_router_video = /** @type {(inputs: Scrape_Router_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video di lancio del router di scraping`)
};

/**
* | output |
* | --- |
* | "Scrape router launch video" |
*
* @param {Scrape_Router_VideoInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const scrape_router_video = /** @type {((inputs?: Scrape_Router_VideoInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scrape_Router_VideoInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_scrape_router_video(inputs)
	if (locale === "pt-BR") return pt_br2_scrape_router_video(inputs)
	if (locale === "es") return es_scrape_router_video(inputs)
	if (locale === "fr") return fr_scrape_router_video(inputs)
	if (locale === "de") return de_scrape_router_video(inputs)
	if (locale === "ru") return ru_scrape_router_video(inputs)
	if (locale === "it") return it_scrape_router_video(inputs)
	return en_scrape_router_video(inputs)
});